import React from "react";
import {Box,HStack,VStack,Text,Tag,IconButton,Separator,Center} from "@chakra-ui/react";
import { FiMoreVertical, FiEdit, FiTrash2, FiStar, FiSave } from "react-icons/fi";
import Tooltip from "../../theme/Tooltip"
export default function AddressTile({
  name,
  phone,
  address1,
  address2,
  landmark,
  city,
  state,
  pin,
  isDefault = true,
  onEdit,
  onMakeDefault,
  onDelete,
  isNew,
  onAddNewAddress,
  id,
  email,
  mode = 'profile',
  setAddress,
  isSelected = false
}) {
  

  return (
    <Box
      role="group"
      bg="white"
      border="1px solid"
      borderColor="border"
      rounded="lg"
      minHeight="170px"
      p={3}
      shadow="sm"
      transition="all 180ms ease"
      _hover={{ shadow: "md", borderColor: "accent" }}
      style={{
         cursor: mode === "checkout" ? "pointer" : "default",
  border: isSelected
    ? "2px solid var(--cr-red-1)" // selected state
    : "1px solid #ddd",             // unselected fallback
  borderRadius: "8px",
  padding: "15px",
  transition: "all 0.2s ease",
      }}
      onClick={mode ==='checkout' ? () => {
        setAddress(id);
      } : null}
    >
      {isNew ? <>
        <Center onClick={onAddNewAddress} height="140px" align="center" flexDirection="column" gap={0} cursor="pointer">
          <Text fontSize="lg" m={0} fontWeight="semibold">Add New Address</Text>
          <Tooltip content="Add" positioning={{ placement: "top" }}>
              <IconButton
                fontSize="xl"
                color="var(--cr-red-logo)"
                variant="ghost"
                size="lg"
                _hover={{ bg: "bg.muted" }}
                _active={{ bg: "bg.subtle" }}
                >
                  <i class="bi bi-house-add-fill"></i>
              </IconButton>
            </Tooltip>
          <Text fontSize="sm">Click here to add new address</Text>
        </Center>
      </>
      
      :
        <>
          <HStack justify="space-between" align="center" gapY={0} mb={0}>
            <HStack gapY={0} align="center">
              <Text fontWeight="semibold" fontSize="md" style={{marginTop :'12px'}}>
                {name}
              </Text>
              {isDefault && (
                <Tag.Root
                  size="sm"
                  bg="accentSubtle"
                  color="accentText"
                  border="1px solid"
                  borderColor="accent"
            
                >
                  <Tag.Label>Default</Tag.Label>
                </Tag.Root>
              ) }
            </HStack>
      { <HStack gapY={0} align="center">
              {mode === 'profile' && !isDefault && (
                <Tooltip content="Make Default" positioning={{ placement: "top" }}>
                  <IconButton
                      color="#EBB512FF"
                      variant="ghost"
                      size="xs"
                      _hover={{ bg: "bg.muted" }}
                      _active={{ bg: "bg.subtle" }}
                      onClick={() => onMakeDefault(id)}
                  >
                       <FiStar size={14} />
                  </IconButton>
                </Tooltip>
              )}
              <Tooltip content="Edit" positioning={{ placement: "top" }}>
                <IconButton
                    color="#31849dff"
                    variant="ghost"
                    size="xs"
                    _hover={{ bg: "bg.muted" }}
                    _active={{ bg: "bg.subtle" }}
                    onClick={() => onEdit({
                      id :  id,
                      name : name,
                      address_line1 : address1,
                      address_line2 : address2,
                      landmark : landmark,
                      city : city,
                      state : state,
                      postal_code : pin,
                      phone : phone,
                      email : email
                    })}
                    >
                        <FiEdit />
                </IconButton>
              </Tooltip>
              {mode === 'profile' && <Tooltip content="Delete" positioning={{ placement: "top" }}>
                <IconButton
                    color="var(--cr-red-logo)"
                    variant="ghost"
                    size="sm"
                    _hover={{ bg: "bg.muted" }}
                    _active={{ bg: "bg.subtle" }}
                    onClick={onDelete}
                >
                    <FiTrash2 />
                </IconButton>
              </Tooltip>}
            </HStack>}
          </HStack>

          <VStack align="start" gapY={-1.5} color="text.muted" fontSize="xs">
            <Text m="0">{address1}</Text>
            {address2 && <Text m="0">{address2}</Text>}
            {landmark && <Text m="0">Landmark: {landmark}</Text>}
            <Text m="0">
              {city}, {state} — {pin}
            </Text>
            {phone && (
              <>
                <Separator  borderColor="border" my={1} />
                <Text m="0">Phone: {phone}</Text>
              </>
            )}
          </VStack>
        </>
      }
    </Box>
  );
}